import { render, staticRenderFns } from "./FooTer.vue?vue&type=template&id=3ee040a1&scoped=true"
import script from "./FooTer.vue?vue&type=script&lang=js"
export * from "./FooTer.vue?vue&type=script&lang=js"
import style0 from "./FooTer.vue?vue&type=style&index=0&id=3ee040a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee040a1",
  null
  
)

export default component.exports